'use strict';

declare var Chartist: any;


module Patersons {


  export interface DashboardScope extends ng.IScope {
    dashboardForm: ng.IFormController;
    data: any;
    responsiveOptions: any;
    events: Patersons.PortfolioDashboardCtrl;
    investorPortfolios: Array<Account>;
    totalCost: number;
    totalValue: number;
    estimatedAnnualIncome: number;
    isLoading: boolean;
    isBannerLoading: boolean;
    isNewsLoading: boolean;
    isMorningMarketLoading: boolean;
    hasNotifications: boolean;
    notificationText: string;
    notificationLink: string;
    notificationStateLink: string;
    bannerConfig: Banner;
    newsConfig: News[];
    latestMorningMarket: Feed;
    headerError: boolean;
    profile: UserProfile;
    userCompany: UserCompany;
    isLoggedIn: boolean;
  }

  export class PortfolioDashboardCtrl extends PortfolioBaseCtrl {

    scope: Patersons.DashboardScope;
    portfolioService: Patersons.PortfolioService;
    bannerService: Patersons.BannerService;
    reportService: Patersons.ReportService;
    researchFeedService: Patersons.ResearchFeedService;
    selectionService: Patersons.SelectionService;
    newsService: Patersons.NewsService;
    filter: any;
    sessionService: Patersons.SessionService;


    static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', '$filter', 'portfolioService', 'bannerService', 'selectionService', 'navigationService', 'reportService', 'newsService', 'researchFeedService', 'sessionService', 'userCompanyService'];

    constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, $filter, portfolioService, bannerService, selectionService, navigationService, reportService, newsService, researchFeedService, sessionService, userCompanyService) {
      super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
      this.scope = $scope;
      this.portfolioService = portfolioService;
      this.selectionService = selectionService;
      this.navigationService = navigationService;
      this.reportService = reportService;
      this.researchFeedService = researchFeedService;
      this.scope.isLoading = false;
      this.bannerService = bannerService;
      this.newsService = newsService;
      this.filter = $filter;            
      this.sessionService = sessionService;

      this.scope.events = this;
      this.scope.headerError = false;
      this.scope.hasNotifications = false;
      this.scope.isLoggedIn = this.sessionService.isLoggedIn();

      // this.getBanner();
      this.getNews();
      // this.getLatestMorningMarket();
      this.getPortfolioData();
      this.getAccoladeNotifications();
      this.navigationService.deactivateAll();
      this.navigationService.activateSection('dashboard');
      if (this.scope.isLoggedIn) {
        //console.log('loadAdviserData');
            this.scope.profile = this.sessionService.getCurrentUserProfile();
            userCompanyService.getUserCompany().then((company) => {
              this.scope.userCompany = company;
            })
        }
    }
    getAccoladeNotifications(){
      var promise = this.reportService.getAllAccoladeNotifications();
      promise.then((result) => {
        console.log(result);
        if(result.length == 1){
          this.scope.notificationText = "A new " + result[0].type + " is available. ";
          this.scope.hasNotifications = true;
          this.scope.notificationLink = result[0].link;
          this.scope.notificationStateLink = null;
        }else if(result.length > 0){
          let firstReportType = result[0].type;
          let allSame = result.every(item => {
            return item.type == firstReportType
          })
          if(allSame){
            this.scope.notificationText = result.length + " new " + firstReportType +"s are available.";
          }else{
            this.scope.notificationText = result.length + " new Accolade Reports are available.";
          }

          switch (firstReportType) {
            case "Accolade Tax Report":
              this.scope.notificationStateLink = "report.tax"
            break;
            case "Accolade Quarterly Report":
              this.scope.notificationStateLink = "report.quarterly"
            break;
            case "Accolade Invoice":
              this.scope.notificationStateLink = "report.invoices"
            break;
            default:
              this.scope.notificationStateLink = "report";
              break;
          }
          this.scope.hasNotifications = true;
          this.scope.notificationLink = null;
        }
      },
        (error) => { // error handling

          console.log("processAccoladeNotifications error");
          console.log(error);
        })

    }
    //https://gist.github.com/bronthulke/cac00b8857c886108069
    getFinancialYear(yearsBack) {
        var financialYearStart, financialYearEnd;
        if (moment().quarter() > 2) {
            financialYearStart = moment().month('July').startOf('month'); // this year's July
            financialYearEnd = moment().add(1, 'years').month('June').endOf('month'); // next year's June
        } else {
            financialYearStart = moment().subtract(1, "years").month('July').startOf('month'); // last year's July
            financialYearEnd = moment().month('June').endOf('month'); // this year's June
        };

        if (yearsBack != undefined) {
            financialYearStart = financialYearStart.subtract(yearsBack, "years");
            financialYearEnd = financialYearEnd.subtract(yearsBack, "years");
        }

        return { "start": financialYearStart.startOf('day'), "end": financialYearEnd.startOf('day') };
    }
    acknowledgeNotification(){
      var promise = this.reportService.acknowledgeAccoladeNotifications();
      promise.then((result) => {
        if(this.scope.notificationLink){
          this.window.location.href = this.scope.notificationLink;
        }else{
          if (this.scope.notificationStateLink){
            this.state.go(this.scope.notificationStateLink)
          }
        }
      },
        (error) => { // error handling
          alert("Error acknowledging notifications. Please try again")
          console.log("acknowledgeNotification error");
          console.log(error);
        })
    }

    getNews() {
      this.scope.isNewsLoading = true;
      let newsCampaignParams = {
        utm_source: 'client_portal',
        utm_medium: 'dashboard_news'
      }
      let max_news = 4;
      var promise: ng.IHttpPromise<any> = this.newsService.getNews();
      promise.then((result) => {
        if (result) {
          let newsConfig: News[] = result['news'];
          newsConfig = newsConfig.slice(0,max_news)
          newsConfig = newsConfig.map((element, index) => {
            if (element.link && element.link.indexOf('http://') !== 0 && element.link.indexOf('https://') !== 0) {
              element.link = 'http://' + element.link
              
            }
            let utmQuery = ''
            Object.keys(newsCampaignParams).forEach((key, index, all) => {
              utmQuery = utmQuery + key + "=" + newsCampaignParams[key] + (index !== all.length - 1 ? "&" : '')
            })
            utmQuery = utmQuery + "&utm_campaign=" + element.title
            if(element.link.indexOf('?') === -1){
              element.link = element.link + "?" + utmQuery;
            }else{
              var lastChar = element.link.substr(element.link.length - 1); 
              if(lastChar == "&"){
                element.link = element.link + utmQuery;
                
              }{
                element.link = element.link + "&" + utmQuery;
              }
            }
            return element;
          });

          this.scope.newsConfig = newsConfig;
          setTimeout(() => {
            $('.clampThis').each(function(index, element) {
              $clamp(element, { clamp: 4, useNativeClamp: true });
          });
          }, 500);

        }
      },
      (error) => { // error handling
        
      })
      .finally(() => {
        this.scope.isNewsLoading = false;
      });
    }



    getLatestMorningMarket() {
      this.scope.isMorningMarketLoading = true;
      var promise = this.researchFeedService.getLatestMorningMarket();
      promise.then((result: Feed) => {
        if (result) {
          this.scope.latestMorningMarket = result;
        }
      },
      (error) => { // error handling
        this.scope.latestMorningMarket = null
      })
      .finally(() => {
        this.scope.isMorningMarketLoading = false;
      });
    }

    getBanner() {
      this.scope.isBannerLoading = true;
      var promise: ng.IHttpPromise<any> = this.bannerService.getCurrent();
      promise.then((result) => {
        if (result && result[0]) {
          let bannerConfig: Banner = result[0];
          let buttonUrl = bannerConfig.buttonUrl.toLowerCase();

          if (buttonUrl.indexOf('http://') !== 0 && buttonUrl.indexOf('https://') !== 0) {
            bannerConfig.buttonUrl = 'http://' + bannerConfig.buttonUrl;
          }

          this.scope.bannerConfig = bannerConfig;
        }
        else {
          this.scope.bannerConfig = new Banner();
          this.scope.bannerConfig.isHidden = true;
        }
      },
      (error) => { // error handling
        this.scope.bannerConfig = new Banner();
        this.scope.bannerConfig.isHidden = true;
      })
      .finally(() => {
        this.scope.isBannerLoading = false;
      });
    }
    goToEOFYStatement(accountId){
      const previousFY = this.getFinancialYear(1)
      this.state.go("holdings", {
        accountId: accountId,
        autoDownloadPDF: true,
        asAt: previousFY.end.toDate()
      });
    }
    getPortfolioData() {

      this.scope.isLoading = true;
      console.log(this.scope.isLoading);
      var promise = this.portfolioService.getCombinedPortfolioData();
      promise.then((result: Array<Account>) => {
        this.scope.investorPortfolios = result;

        for (var i = 0; i < this.scope.investorPortfolios.length; i++) {
          this.getPortfolioValue(this.scope.investorPortfolios[i]); // error handling: --
        }

        this.scope.isLoading = false;
        console.log(this.scope.isLoading);
      },
      (reason) => { // error handling
        this.scope.isLoading = false;
        this.portfolioService.errorHandler = reason.data;
      });
    }

    getPortfolioValue(account: Account) {
      let promise = this.portfolioService.getPortfolioValue(account);
      promise.then((result: any) => {
        if (result) {
          account.totalMovementToday = result.currentMovementValue;
          account.totalMovementPercentage = result.currentMovementPercent;
          account.totalHoldingsValue = result.currentValue;
          account.headerLoaded = true;
        }
      },
        (error) => { // error handling
          account.totalMovementToday = undefined;
          account.totalMovementPercentage = undefined;
          account.totalHoldingsValue = undefined;
          //this.scope.headerError = true;
          account.headerLoaded = true;
        });
    }

    goToPorfolioOverview(accountId: string) {
      this.selectionService.selectedAccountId = accountId;
      this.state.go("viewPortfolio");
    }

    goToHoldings(accountId: string) {
      this.selectionService.selectedAccountId = accountId;
      this.state.go("holdings");
    }

    getAccount(accountId: string): Account {
      var accounts: Array<Account> = this.scope.investorPortfolios.filter(x => x.accountId == accountId);

      if (accounts) {
        return accounts[0];
      }

      return null;
    }
  }
}
